import React, { createRef, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import {Button, Dropdown, Checkbox, Modal, Input, Message, Form, TextArea} from 'semantic-ui-react';

import {colors, fontSizes, fonts, spacings, shadow, buttons} from 'style';
import DatabaseService from 'services/DatabaseService.js';
import { useDispatch } from 'react-redux';
import { SET_LOADING_OVERLAY_ENABLE } from 'actions/types/index.js';

var style = {
    content: {
        fontSize: fontSizes.body,
        lineHeight: '1.5',
        backgroundColor: colors.themeGrey,
    },
    saveButton: {
        ...buttons.base,
        ...buttons.mediumWidth,
        float: 'right',
        marginLeft: spacings.small,
        marginRight: spacings.small,
    },
    buttonRow: {
        height: '50px',
    },
    flex: {
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem',
        alignItems: 'center',
        margin: "1rem"
    }
};


const AwardBonusGemsModal = ({ t, 
                                 onDeleteAnnouncement,
                                 onClose,
                                 deleteModalRef,
                                 required,
                                 roles,
                                 ...props
                               }) => {

    const fileSelector = createRef()
    const [gemsToAward, setGemsToAward] = useState()
    const [rewardActionToAward, setRewardActionToAward] = useState()
    const [csvData, setCsvData] = useState()
    const dispatch = useDispatch()

    const onUploadCsv = () => {
        fileSelector.current.click();
    }

    const onFileSelect = (event) => {
        const [file,] = event.target.files

        if (file.type != 'text/csv'){
            window.alert('Invalid CSV File')
            return
        }
        dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:true});
        event.target.value=null
        
        const reader = new FileReader();
        reader.onerror= (e) => { 
            window.alert(e)
            dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false})
        };
        reader.onload = async (e) => {
            console.log(e)
            setCsvData(e.target.result.replace(/^[^\n]*\r?\n?/, ''))
            dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false});
        };
        reader.readAsText(file, 'UTF-8');
    }

    const onChangeCsvData = async (e) => {
        setCsvData(e.target.value)
    }

    const onSubmit = async (event) => {
        event && event.preventDefault();
        
        dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:true});
        try {
            let firstLineLength = (csvData.match(/^[^\n\r]*/)?.[0] ?? '').split(',').length;
            let headers = ['email','resources','rewardActionId']


            const result = await DatabaseService.awardBonusGems({
                resources: gemsToAward,
                rewardActionId: rewardActionToAward,
                companyEmployees: { csv: `${headers.slice(0, firstLineLength).join(',')}\r\n${csvData}` }
            })
            
            onClose();
        } catch(err) {
            window.alert('An error occurred - check logs');
            console.error(err)
        } finally {
            dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false});
        }
    }
    
    return (
        <Modal open style={style.content} onClose={onClose} size='small'>
            <Modal.Content>
                {/* <DeletePromptContainer ref = {deleteModalRef} onDeleteConfirmation = {onDeleteAnnouncement} /> */}
                <Modal.Description>
                    <Modal.Header>
                        <div style={{...style.flex, fontSize: fontSizes.h4}}>
                            Award Bonus Gems
                        </div>
                    </Modal.Header>
                    <Form onSubmit={onSubmit}>
                        <div style={style.flex}>
                            <span>Global Bonus Gems (optional): </span>
                            <input type='number' placeholder='Enter gems' 
                                style={{width:'auto', padding: '0.5rem'}}
                                onChange={(e)=>setGemsToAward(e.target.value)}
                                />
                            
                        
                        </div>
                        { localStorage.master == 'true' && <div style={style.flex}>
                            <span>Global Bonus Reward Action (optional): </span>
                            <input type='number' placeholder='Enter Reward Action ID' 
                                style={{width:'auto', padding: '0.5rem'}}
                                onChange={(e)=>setRewardActionToAward(e.target.value)}
                                />
                        </div> }
                        <div>

                        <div style={{ textAlign:"center", fontSize: fontSizes.h4}}>
                            Users and Individual Bonuses
                        </div>
                            <TextArea rows="10"
                                placeholder={`email,resources,rewardActionId
...`}
                                value={csvData} 
                                onChange={onChangeCsvData}></TextArea>
                            <input ref={fileSelector} type="file" style={{display:'none'}} onChange={onFileSelect} />
                            <span>Upload Users (CSV): </span>
                            <Button type='button' style={style.button} 
                                onClick={onUploadCsv}>{t('Upload Users')}
                            </Button>
                         
                        </div>
                        <div>
                            NOTE - csv must include the title "email" (all lowercase) in column A followed by list of emails in rows below it. The columns "resources" and "rewardActionId" are optional.
                        </div>
                            
                        <div style={style.flex}>
                            <Button style={style.saveButton} disabled={!Boolean(csvData)} type='submit'>{t('Save')}</Button>
                        </div>
                       
                        
                    </Form>
                </Modal.Description>
            </Modal.Content>
        </Modal>
    )
}

export default withTranslation('announcements')(AwardBonusGemsModal);
